export enum PubSubActions {
  /** Reload the Flags Track */
  REFETCH_REGION_FLAGS = "GENOME-VIEWER/REFETCH_REGION_FLAGS",
  /** User logout. Flush stores, ... */
  LOGOUT = "LOGOUT",
  /** WebSocket "file" events */
  FILE = "WEBSOCKET/FILE",
  /** File editing events */
  FILE_EDIT = "FILE/EDIT",
  /** Project Tag Update */
  UPDATE_TAGS = "PROJECTS/TAGS/UPDATE",
}
